import { render, staticRenderFns } from "./Tarjetas.vue?vue&type=template&id=71aa6de6"
import script from "./Tarjetas.vue?vue&type=script&lang=js"
export * from "./Tarjetas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports